import * as React from "react";
import { CustomerNotification } from "@shared-ui/customer-notifications";
import { getBexApiContext, Context } from "bernie-context";
import { AnalyticsStore, PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

interface CustomerNotificationsProps {
  context?: Context;
  analytics?: AnalyticsStore;
  location: string;
  page?: PageStore;
}

interface Identity {
  pageId: string;
  lineOfBusiness: string;
  funnelLocation: string;
}

const getIdentity = (page: PageStore): Identity => {
  const identifiers = page.pageId.split(",").map(identifier => identifier.trim());

  return {
    pageId: identifiers[0],
    lineOfBusiness: identifiers[1],
    funnelLocation: identifiers[2]
  };
};

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject(
  "analytics",
  "context",
  "page"
)((props: CustomerNotificationsProps) => {
  const { analytics, context, location, page } = props;

  if (!page || !page.pageId || !context) {
    return null;
  }

  const identity = getIdentity(page);
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || "RFRR Action Event", analytics.omnitureData, null, true);
  };

  return (
    <Experiment name={"SURFACE_Travel_Advisory_V2"}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <div className="all-b-margin-three">
          <CustomerNotification
            inputs={{
              context: getBexApiContext(context),
              lineOfBusiness: identity.lineOfBusiness,
              funnelLocation: identity.funnelLocation,
              notificationLocation: location
            }}
            analyticsCallback={analyticsCallback}
          />
        </div>
      </ExperimentVariant>
    </Experiment>
  );
});
